/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect, useContext } from 'react';

import 'src/App.scss';
import './style.scss';

import { ReactComponent as ArrowL } from 'src/assets/icons/arrowL.svg';
import { ReactComponent as ArrowR } from 'src/assets/icons/arrowR.svg';
import { ReactComponent as Close } from 'src/assets/icons/close.svg';
import { ReactComponent as EmbarqueIcon } from 'src/assets/icons/embarque.svg';
import { ReactComponent as LogoutIcon } from 'src/assets/icons/logout.svg';
import { ReactComponent as Menu } from 'src/assets/icons/menu.svg';
import { ReactComponent as UserIcon } from 'src/assets/icons/user2.svg';
import { ReactComponent as Admin } from 'src/assets/icons/admin.svg';
import { ReactComponent as CobrancaIcon } from 'src/assets/icons/cobranca.svg';

import Dashboard from 'src/components/Dashboard';
import { LoadGif2 } from 'src/components/LoadGif2';
import { LogContext } from 'src/components/LogProvider';
import UserDetails from 'src/components/UserDetails';
import {
  Documentos,
  Aprovacoes,
  Assinatura,
  Administrativo,
  Cobranca,
  CustomInput,
} from 'src/components';

import List from 'src/pages/list';

import { GetProcesso, isValid, Logout } from 'src/services/auth';

import Logo from 'src/assets/base/logoNewte.jpg';
import DefIcon from 'src/assets/base/page.svg';

export const newTabRef = {
  setNewTab: null,
};

export function newTab(title, content) {
  if (newTabRef.setNewTab) {
    newTabRef.setNewTab(title, content);
  } else {
    console.warn('Erro ao abrir nova página.');
  }
}

function Home() {
  //const [tableName, setTableName] = useState('');
  const [currentTab, setCurrentTab] = useState(-1);
  const [hasTabs, setHasTabs] = useState(false);
  const [hasScroll, setHasScroll] = useState(false);
  const [popupName, setPopupName] = useState('');
  const [showGaveta, setShowGaveta] = useState(false);
  const [showsideMenu, setShowSideMenu] = useState(false);
  const [tabsContent, setTabsContent] = useState([]);
  const [showDetails, setShowDetails] = useState(false);

  const empLogo = localStorage.getItem('empLogo');
  const menus = JSON.parse(localStorage.getItem('menus') || '{}');
  const usuario = localStorage.getItem('nomeUsu');

  const tabsRef = useRef(null);

  const { loadIndex, setLoadIndex } = useContext(LogContext);

  const isAdm =
    localStorage.getItem('IsAdm') === 'S' ||
    localStorage.getItem('IsAdm') === true;

  const [identificador, setIdentificador] = useState('');
  const [testPorta, setTestPorta] = useState('');
  const [testData, setTestData] = useState('');
  const [testToken, setTestToken] = useState('');
  const [testRetorno, setTestRetorno] = useState('');

  const plugTokenList = {
    'coocafe.newlink.app.br': '',
    'emflora.newlink.app.br': '',
    'equilibrio.newlink.app.br': '',
    'nooa.newlink.app.br': '',
    'tpj.newlink.app.br': '',
    'vixport.newlink.app.br':
      'l6pZNeWzopwX9TVunzKbhLKYQRVHQDvcu1TPfG8t0b3KWMw1CKtnEtqpD6QwFnPVhN27gNvENgisYInQUX2ZmNU4uPcQk6zmJKKQzQbE663SXoj2rPgth4TrzyBsaXJX8ItR6GKFpjiHVpmuYdtC50YAVO2rT6Vb6QddJewA90D9DtXYURXhppsFuJDiGo4EkTIpjWpUv2uL0H1serjPbn3RBsFQACuZbR4wgo7ldVJubVVhgho2vD3npT8nqbjmWAheLYkWBDfMXpG3EC4tRN0miD5yHbTAOdoxvqyJcGucvUJLcIIcKOf6oT1nXoUZmkiU0XCKKiP4GO19J',
    'nicchio.newlink.app.br':
      'l6pZNeWzopwX9TVunzKbhLKYQRVHQDvcu1TPfG8t0b3KWMw1CKtnEtqpD6QwFnPVhN27gNvENgisYInQUX2ZmNU4uPcQk6zmJKKQzQbE663SXoj2rPgth4TrzyBsaXJX8ItR6GKFpjiHVpmuYdtC50YAVO2rT6Vb6QddJewA90D9DtXYURXhppsFuJDiGo4EkTIpjWpUv2uL0H1serjPbn3RBsFQACuZbR4wgo7ldVJubVVhgho2vD3npT8nqbjmWAheLYkWBDfMXpG3EC4tRN0miD5yHbTAOdoxvqyJcGucvUJLcIIcKOf6oT1nXoUZmkiU0XCKKiP4GO19J',
    'tvparanaiba.newlink.app.br':
      '6xLnkXriV75O4UkWVtbfKOMQDiV47aRBISGbCVXnAKqbx5uNaqfeIaOBVdZCkitk1gDaOgxdMQA9wNRyUQGbAiFboWZsPEK0u7QoDbWiO884L93McTE03m3HjQPMGbVIf2a6RQVi5RmtEaxRmHlWebljSLW3MpFHa2NRrvei3m1NbtluaOYPZc0FXTH1q2TeMMl7coc3rSLUc0fEjMndec53pGWff26aCY4HUTia9nxhvkhRdMpTYzx3y5aE5ZU2NmEFRdX01qrvijn35sBD2iT7pFMjdOuw1mWuRvDCaxEbxopzSsuYo5YJhrHtzoCXWSaNd0ceoROLb6ts9',
    'xamegobom.newlink.app.br': '',
    'sorvedoces.newlink.app.br': '',
    'ceres.newlink.app.br': '',
    localhost:
      '6xLnkXriV75O4UkWVtbfKOMQDiV47aRBISGbCVXnAKqbx5uNaqfeIaOBVdZCkitk1gDaOgxdMQA9wNRyUQGbAiFboWZsPEK0u7QoDbWiO884L93McTE03m3HjQPMGbVIf2a6RQVi5RmtEaxRmHlWebljSLW3MpFHa2NRrvei3m1NbtluaOYPZc0FXTH1q2TeMMl7coc3rSLUc0fEjMndec53pGWff26aCY4HUTia9nxhvkhRdMpTYzx3y5aE5ZU2NmEFRdX01qrvijn35sBD2iT7pFMjdOuw1mWuRvDCaxEbxopzSsuYo5YJhrHtzoCXWSaNd0ceoROLb6ts9',
  };

  useEffect(() => {
    const baseUrl = window.location.hostname;
    setIdentificador(baseUrl);
    localStorage.setItem('plugtoken', plugTokenList[baseUrl]);

    newTabRef.setNewTab = (title, content) => {
      setTabsContent((prevTabs) => {
        const existingTabIndex = prevTabs.findIndex(
          (tab) => tab?.title === title
        );

        if (existingTabIndex === -1) {
          setCurrentTab(prevTabs.length);
          return [...prevTabs, { title, content }];
        } else {
          setCurrentTab(existingTabIndex);
          return prevTabs;
        }
      });
    };
  }, []);

  function setNewTab(title, content) {
    setTabsContent((prev) => [
      ...prev,
      {
        title: title,
        content: content,
      },
    ]);
  }

  useEffect(() => {
    const checkScroll = () => {
      if (tabsRef.current) {
        setHasScroll(tabsRef.current.scrollWidth > tabsRef.current.clientWidth);
      }
    };

    checkScroll();
    window.addEventListener('resize', checkScroll, { passive: true });
    return () => window.removeEventListener('resize', checkScroll);
  }, [tabsContent]);

  const tabRefs = useRef([]);

  useEffect(() => {
    if (currentTab !== -1 && tabRefs.current[currentTab]) {
      tabRefs.current[currentTab].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }, [currentTab]);

  useEffect(() => {
    if (tabsContent.every((item) => item === null)) {
      setHasTabs(false);
    } else {
      setHasTabs(true);
    }
  }, [tabsContent]);

  const isMobile = window.innerWidth <= 768;
  return (
    <div className="Home">
      {showDetails && (
        <button onClick={() => setShowDetails(false)} className="fade" />
      )}
      {showDetails && <UserDetails onClose={() => setShowDetails(false)} />}

      <button
        className="mobileMenu"
        onClick={() => setShowSideMenu(!showsideMenu)}
      >
        <Menu />
        <div>
          <img src={empLogo} />
        </div>
      </button>

      <div className={`SideMenu ${showsideMenu ? 'active' : ''}`}>
        <div className={`SideMenuContent ${showsideMenu ? 'active' : ''}`}>
          <div className="menuHeader">
            <button
              className={`CloseMenu ${showsideMenu ? 'active' : ''}`}
              onClick={() => setShowSideMenu(!showsideMenu)}
            >
              <span className={`icon ${showsideMenu ? 'active' : ''}`}>
                <Menu />
              </span>
            </button>
          </div>

          <div className="scroll">
            <div
              style={{ marginBottom: '0.5rem' }}
              key="Usuario"
              className="menuItem"
            >
              <button /*onClick={() => setShowDetails(true)}*/>
                <span className="icon">
                  <UserIcon />
                </span>
                <p className="userName">{usuario.replace(/\./g, ' ')}</p>
              </button>
            </div>

            {Object.entries(menus)?.map(([key, item], index) => {
              if (
                typeof item === 'object' &&
                key !== 'Documentos' &&
                key !== 'Aprovações'
              ) {
                return (
                  <div key={key} className="menuItem">
                    <button
                      onClick={() => {
                        if (window.innerWidth <= 768) {
                          setShowSideMenu(false);
                        }

                        setPopupName('');
                        setShowGaveta(false);
                        const existingTabIndex = tabsContent.findIndex(
                          (tab) => tab?.title === key
                        );

                        if (existingTabIndex === -1) {
                          setTabsContent((prev) => [
                            ...prev,
                            {
                              title: key,
                              content: (
                                <List
                                  data={item}
                                  tabsContent={tabsContent}
                                  setTabsContent={setTabsContent}
                                  setCurrentTab={setCurrentTab}
                                />
                              ),
                            },
                          ]);
                          setCurrentTab(tabsContent.length);
                        } else {
                          setCurrentTab(existingTabIndex);
                        }
                      }}
                    >
                      <span className="icon">
                        {isValid(item.icone) ? (
                          <img
                            src={item.icone}
                            onError={(e) => {
                              e.currentTarget.src = DefIcon;
                            }}
                          />
                        ) : (
                          <EmbarqueIcon />
                        )}
                      </span>
                      <p>{key}</p>
                    </button>
                  </div>
                );
              }
              return null;
            })}

            {Object.keys(menus).includes('Documentos') && (
              <div key="Documentos" className="menuItem">
                <button
                  onClick={() => {
                    if (window.innerWidth <= 768) {
                      setShowSideMenu(false);
                    }

                    newTab('Documentos', <Documentos />);
                  }}
                >
                  <span className="icon">
                    {isValid(menus['Documentos']?.icone) ? (
                      <img
                        src={menus['Documentos']?.icone}
                        alt="Ícone"
                        onError={(e) => {
                          e.currentTarget.src = DefIcon;
                        }}
                      />
                    ) : (
                      <EmbarqueIcon />
                    )}
                  </span>
                  <p>Documentos</p>
                </button>
              </div>
            )}

            {Object.keys(menus).includes('Aprovações') && (
              <div key="Aprovacoes" className="menuItem">
                <button
                  onClick={() => {
                    if (window.innerWidth <= 768) {
                      setShowSideMenu(false);
                    }

                    newTab('Aprovações', <Aprovacoes />);
                  }}
                >
                  <span className="icon">
                    {isValid(menus['Aprovações']?.icone) ? (
                      <img
                        src={menus['Aprovações']?.icone}
                        alt="Ícone"
                        onError={(e) => {
                          e.currentTarget.src = DefIcon;
                        }}
                      />
                    ) : (
                      <EmbarqueIcon />
                    )}
                  </span>
                  <p>Aprovações</p>
                </button>
              </div>
            )}

            {isAdm && (
              <div key="Cobranca" className="menuItem">
                <button
                  onClick={() => {
                    if (window.innerWidth <= 768) {
                      setShowSideMenu(false);
                    }

                    newTab('Cobrança Bancária', <Cobranca />);
                  }}
                >
                  <span className="icon">
                    <CobrancaIcon
                      style={{ width: '2.5rem', height: '2.5rem' }}
                    />
                  </span>
                  <p>Cobrança</p>
                </button>
              </div>
            )}

            {isAdm && (
              <div key="Administrativo" className="menuItem">
                <button
                  onClick={() => {
                    if (window.innerWidth <= 768) {
                      setShowSideMenu(false);
                    }

                    newTab('Administrativo', <Administrativo />);
                  }}
                >
                  <span className="icon">
                    <Admin />
                  </span>
                  <p>Administrativo</p>
                </button>
              </div>
            )}

            {(Object.keys(menus).includes('Assinatura') || isAdm) && (
              <div key="Assinatura" className="menuItem">
                <button
                  onClick={() => {
                    if (window.innerWidth <= 768) {
                      setShowSideMenu(false);
                    }

                    newTab('Assinatura', <Assinatura />);
                  }}
                >
                  <span className="icon">
                    {isValid(menus['Assinatura']?.icone) ? (
                      <img
                        src={menus['Assinatura']?.icone}
                        alt="Ícone"
                        onError={(e) => {
                          e.currentTarget.src = DefIcon;
                        }}
                      />
                    ) : (
                      <EmbarqueIcon />
                    )}
                  </span>
                  <p>Assinatura</p>
                </button>
              </div>
            )}
          </div>

          <div className={`logo ${showsideMenu ? 'active' : ''}`}>
            <img
              src={Logo}
              onError={(e) => {
                e.currentTarget.src = DefIcon;
              }}
            />
          </div>
          <button
            onClick={() => {
              Logout();
            }}
            className={`logout ${showsideMenu ? 'active' : ''}`}
          >
            <LogoutIcon />
            Sair
          </button>
        </div>
      </div>

      <div className={`wrapper ${showsideMenu ? 'active' : ''}`}>
        <div className="menuHeader">
          {hasScroll && (
            <div className="control">
              <button
                onClick={() => {
                  let newIndex;

                  if (currentTab === 0) {
                    newIndex = -1;
                  } else if (currentTab === -1) {
                    newIndex = tabsContent.length - 1;
                  } else {
                    newIndex = [...tabsContent]
                      .slice(0, currentTab)
                      .reverse()
                      .findIndex((tab) => tab?.content);

                    if (newIndex !== -1) {
                      newIndex = currentTab - (newIndex + 1);
                    }
                  }

                  setCurrentTab(newIndex);
                }}
              >
                <ArrowL />
              </button>
              <button
                onClick={() => {
                  const newIndex = tabsContent.findIndex(
                    (tab, i) => i > currentTab && tab?.content
                  );

                  setCurrentTab(newIndex);
                }}
              >
                <ArrowR />
              </button>
            </div>
          )}

          <div
            ref={tabsRef}
            className={`tabs ${showsideMenu ? 'scale' : ''} ${hasScroll ? 'hascontrol' : ''}`}
          >
            <div>
              <div className="tabItems">
                {(hasTabs || isMobile) && (
                  <div
                    ref={(el) => (tabRefs.current[-1] = el)}
                    className={`aba abaHome ${currentTab === -1 ? 'active' : ''}`}
                  >
                    <button onClick={() => setCurrentTab(-1)}>Home</button>
                  </div>
                )}

                {tabsContent.map(
                  (tab, i) =>
                    tab !== null && (
                      <div
                        key={i}
                        ref={(el) => (tabRefs.current[i] = el)} // Associa a ref a cada aba
                        className={`aba ${currentTab === i ? 'active' : ''} ${loadIndex[i] === true ? 'loading' : ''}`}
                      >
                        <button onClick={() => setCurrentTab(i)}>
                          {tab.title}
                          <LoadGif2 />
                        </button>
                        <button
                          onClick={() => {
                            setTabsContent((prev) => {
                              const newArray = [...prev];
                              newArray[i] = null;
                              return newArray;
                            });

                            if (currentTab === i) {
                              const prevTabIndex = [...tabsContent]
                                .slice(0, i)
                                .reverse()
                                .findIndex((tab) => tab !== null);

                              if (prevTabIndex !== -1) {
                                setCurrentTab(i - (prevTabIndex + 1));
                              } else {
                                setCurrentTab(-1);
                              }
                            }
                          }}
                        >
                          <Close />
                        </button>
                        <div className="over" />
                      </div>
                    )
                )}
              </div>
              <hr />
            </div>
          </div>
        </div>

        {/* TESTE NEW BACKEND 
        <button className="TESTbutton" onClick={() => setShowTEST(true)}>
          Test Request
        </button>
        {showTEST && (
          <div className="modal absoluteCenter mainShadow TESTform">
            <div>
              <CustomInput
                Type="text"
                PlaceHolder="Identificador"
                DefaultValue={identificador}
                OnChange={(e) => setIdentificador(e.target.value)}
              />
              <CustomInput
                Type="text"
                PlaceHolder="Porta"
                OnChange={(e) => setTestPorta(e.target.value)}
              />
              <CustomInput
                Type="text"
                PlaceHolder="Subistituir Token"
                OnChange={(e) => setTestToken(e.target.value)}
              />
              <label> Data: </label>
              <textarea
                value={testData}
                onChange={(e) => setTestData(e.target.value)}
              />
            </div>
            <div className="controls">
              <button
                className="mainButton gray"
                onClick={() => setShowTEST(false)}
              >
                Cancel
              </button>
              <button
                className="mainButton turquoise"
                onClick={() =>
                  handleTest(testPorta, identificador, testData, testToken)
                }
              >
                TEST
              </button>
            </div>
            <p> {testRetorno} </p>
          </div>
        )}*/}

        <Dashboard
          ClassName={`${currentTab === -1 || !hasTabs ? 'show' : 'hide'}`}
        />

        {tabsContent.map((tab, index) => {
          if (tab !== null)
            return (
              <div
                className={`tabContent ${index === currentTab ? 'show' : 'hide'}`}
                key={index}
              >
                {tab.content}
              </div>
            );
        })}
      </div>
    </div>
  );
}

export default Home;
